<div class="group_input">
  <textarea #appTextarea [(ngModel)]="value" (ngModelChange)="onChangeTextArea()" [attr.required]="required" [readonly]="readonly"></textarea>
  <span class="bar"></span>
  <label><span *ngIf="required">* </span>{{ title }}</label>
</div>
